import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import { dataResources } from 'utils/constants';
import styles from './codiespectador.module.scss';

const { basePath } = dataResources;

const ALT_PER_CODI = {
    TP: 'Codi ètic: tots els públics',
    IN: 'Codi ètic: infantil',
    N: '',
    XX: 'Codi ètic: X',
    D: '',
    VO: 'Versió original',
    AD: 'Audiodescripció',
    ST: '',
    Subtitols: 'Subtítols',
    Orella: '',
    Apte: 'Codi ètic: apte'
};

const getAltCodiEspectador = (codiEdat) => {
    if (!codiEdat) return '';
    return !isNaN(codiEdat) ? `Codi ètic: ${codiEdat} anys` : ALT_PER_CODI[codiEdat] || codiEdat;
};

export default function CodiEspectador(props) {
    const { codi, mida, className, estil, directe } = props;

    let codiEdat = codi?.replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');

    //ELIMINAR CODIS ÈTICS TP
    if ((codiEdat === 'TP' && directe === false) || codiEdat === 'DA') {
        return false;
    }

    const styleIcona = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let src = basePath + '/_resources/icones/codisEspectador/codisEspectador' + codiEdat + '.svg?v=JIT_ENV_RESOURCES_VERSION';

    const imageLoader = ({ src }) => {
        return `${src}`;
    };

    return (
        codiEdat && (
            <span className={styleIcona} data-testid={`codi-espectador-${codiEdat}`}>
                <Image
                    loader={imageLoader}
                    width={codiEdat === 'AD' ? mida * 1.6 : codiEdat === 'IN' ? mida * 3.12 : mida}
                    height={mida}
                    alt={getAltCodiEspectador(codiEdat)}
                    src={src}
                    unoptimized={true}
                />
            </span>
        )
    );
}

CodiEspectador.defaultProps = {
    codi: '',
    mida: '20',
    className: '',
    directe: false
};
